module.exports = __webpack_public_path__ + "media/3-11.0da7dcd4.wav";